import { Label } from "@/components/ui/label";
import { useGetOne } from "react-admin";
import { ChangePassword } from "./ChangePassword";
import { useUserContext } from "@/context/UserContext";

const FieldRow = ({
    label,
    description,
    component,
}: {
    label: string;
    description?: string;
    component: React.ReactNode;
}) => {
    return (
        <div className="flex items-center py-5 border-t">
            <div className="w-1/3 pr-4">
                <Label className="block text-[18px] font-medium mb-1">{label}</Label>
                {description && <p className="text-[14px] text-muted-foreground">{description}</p>}
            </div>
            <div className="w-1/4">{component}</div>
        </div>
    );
};

const AccessLogin = () => {
    const { decodedToken } = useUserContext();

    const { isPending, error } = useGetOne('settings', { id: decodedToken?.settings.id });

    if (isPending) { return <p>Loading</p>; }
    if (error) { return <p>ERROR</p>; }

    return (
        <div className="space-y-2 mt-6">
            <FieldRow
                label="Change Password"
                description="Change your account password"
                component={
                    <ChangePassword />
                }
            />
        </div>
    );
};

export default AccessLogin;
